"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunicationTransportCreate = exports.ObjectReferenceCreate = exports.CommunicationTemplateTransport = exports.CommunicationTransport = exports.ObjectReference = exports.DestinationTransport = exports.ObjectType = exports.ObjectTypes = exports.CommunicationType = exports.CommunicationTypesLabels = exports.CommunicationTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.CommunicationTypes = [
    //these don't exist yet
    // 'SUBSCRIPTION_PAUSE',
    // 'SUBSCRIPTION_CANCEL',
    // 'SUBSCRIPTION_PAUSE_REMINDER',
    // 'SUBSCRIPTION_RESUME_REMINDER',
    // 'SUBSCRIPTION_CONFIRMATION',
    'ROLL_OFF_ORDER_CONFIRMATION',
    // 'ROLL_OFF_ORDER_UPDATE',
    'ROLL_OFF_ORDER_CANCEL',
    'ROLL_OFF_DRIVER_ENROUTE',
    'WAYSTE_AUTOPAY_RECEIPT',
    'ROLL_OFF_DAY_BEFORE_SERVICE_REMINDER',
    'ROLL_OFF_DAY_OF_SERVICE_REMINDER',
    'ROLLOFF_INVOICE_PAYMENT',
    'WAYSTE_INVOICE_ISSUE_RECEIPT',
    'WAYSTE_AUTOPAY_FAILURE',
    'WAYSTE_INVOICE_PAYMENT_RECEIPT',
];
exports.CommunicationTypesLabels = {
    ROLL_OFF_ORDER_CONFIRMATION: 'Order Confirmation & Service Agreement',
    ROLL_OFF_ORDER_CANCEL: 'Order Cancellation',
    ROLL_OFF_DRIVER_ENROUTE: 'Driver on the Way',
    WAYSTE_AUTOPAY_RECEIPT: 'Autopay Receipt',
    ROLL_OFF_DAY_BEFORE_SERVICE_REMINDER: 'Day Before Service Reminder',
    ROLL_OFF_DAY_OF_SERVICE_REMINDER: 'Day of Service Reminder',
    ROLLOFF_INVOICE_PAYMENT: 'Order Invoice Payment',
    WAYSTE_INVOICE_ISSUE_RECEIPT: 'Subscription Invoice',
    WAYSTE_AUTOPAY_FAILURE: 'Autopay Failed',
    WAYSTE_INVOICE_PAYMENT_RECEIPT: 'Subscription Invoice Receipt',
};
exports.CommunicationType = typebox_1.Type.Union(exports.CommunicationTypes.map((communicationType) => typebox_1.Type.Literal(communicationType)));
//NB these are the DB table names, as they are more meaningful than the actual object types
exports.ObjectTypes = [
    'Orders', //roll off order
    'commercial_subscription', //subscription
    'WaysteReceivables', //invoice
    'billing_activity', //billing activity
];
exports.ObjectType = typebox_1.Type.Union(exports.ObjectTypes.map((type) => typebox_1.Type.Literal(type)));
exports.DestinationTransport = typebox_1.Type.Object({
    email: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String())),
    sms: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String())),
    usePreferences: typebox_1.Type.Optional(typebox_1.Type.Boolean({ default: false })),
    communicationType: typebox_1.Type.Optional(exports.CommunicationType),
});
exports.ObjectReference = typebox_1.Type.Object({
    id: typebox_1.Type.String({
        format: 'uuid',
    }),
    objectID: typebox_1.Type.String({
        format: 'uuid',
    }),
    type: exports.ObjectType,
});
exports.CommunicationTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({
        format: 'uuid',
    }),
    haulerID: typebox_1.Type.String({
        format: 'uuid',
    }),
    customerID: typebox_1.Type.String({
        format: 'uuid',
    }),
    communicationType: exports.CommunicationType,
    destination: exports.DestinationTransport,
    sendTime: typebox_1.Type.Optional(typebox_1.Type.String({
        format: 'date-time',
    })),
    objectReferences: typebox_1.Type.Optional(typebox_1.Type.Array(exports.ObjectReference)),
});
exports.CommunicationTemplateTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({
        format: 'uuid',
        description: 'This is ignored on update and create',
    }),
    haulerId: typebox_1.Type.String({
        format: 'uuid',
        description: 'This is ignored on update and create',
    }),
    type: exports.CommunicationType,
    template: typebox_1.Type.String(),
    destinationType: typebox_1.Type.Union([typebox_1.Type.Literal('sms'), typebox_1.Type.Literal('email')]),
    subject: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.ObjectReferenceCreate = typebox_1.Type.Omit(exports.ObjectReference, ['id']);
exports.CommunicationTransportCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.CommunicationTransport, ['id', 'objectReferences']),
    typebox_1.Type.Object({ objectReferences: typebox_1.Type.Array(exports.ObjectReferenceCreate) }),
]);
//# sourceMappingURL=communication.js.map